<!--
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2022-06-30 16:05:06
 * @LastEditors: gaoyuanyuan
 * @LastEditTime: 2026-03-24 16:35:46
-->
<template>
    <!-- 历史记录 -->
    <div :class="['history-list', $i18n.locale]" ref="sectionBox" @touchstart="touchstart" @touchmove="touchmove">
        <div>
            <div class="header-menu">
                <span>
                    <img src="@/assets/images/sidebar/arrow-left.png" alt class="menu-info" @click.prevent="goBack()" />
                </span>
                <div>
                    <img
                        v-if="!status"
                        src="@/assets/images/sidebar/edit-box-line@2x.png"
                        alt
                        class="menu-info"
                        @click.prevent="tipsSubmit(1)"
                    />
                    <img
                        v-else
                        src="@/assets/images/report/checkbox-circle-line@2x.png"
                        alt
                        class="menu-info img"
                        @click.prevent="tipsSubmit(2)"
                    />
                </div>
            </div>
            <!-- <div v-for=" (item, index) in dataArray" :key="index">
                <div class="scantime">{{item.year}}</div>
                <div class="centre-menu" v-for=" (secondItem, indef) in item.data" :key="indef" @click="goToReport(index, indef)">
                    <img src="@/assets/images/Fill 14.png" alt="" class="fill-left">
                    <div class="content">
                        <span class="time">{{secondItem.createTime | getDealWith}}</span>
                        <br/>
                        <span class="title">
                            {{secondItem.biaMeasure === 1 ? $t('report.tabPane.labelList[2]') : ''}}
                            {{secondItem.biaMeasure === 1 && secondItem.staticEval === 1 && secondItem.shoulder !== 1 ? '、' : ''}}
                            {{secondItem.biaMeasure === 1 && secondItem.shoulder === 1 ? '、' : ''}}
                            {{secondItem.staticEval === 1 ? $t('report.tabPane.labelList[3]') : ''}}
                                                                                                {{secondItem.staticEval === 1 && secondItem.shoulder === 1 ? '、' : ''}}
                                                                                                {{secondItem.shoulder === 1 ? $t('report.tabPane.labelList[4]') : ''}}
                                                                                            </span>
                                                                                        </div>
                                                                                        <img src="@/assets/images/sidebar/arrow-right.png" alt="" class="arrow-right" >
                                                                                    </div>
            </div>-->
            <van-list
                v-model="loading"
                :loading-text="$t('model.btn.loading')"
                :finished="finished"
                finished-text
                @load="onLoad"
                :offset="10"
            >
                <div v-if="isRead">
                    <van-cell v-for="(item, index) in list" :key="index">
                        <div class="scantime">{{ item.year }}</div>
                        <div v-for="(secondItem, indef) in item.data" :key="indef">
                            <div
                                :class="['centre-menu-item', { 'm60History': deviceType === 4 }]"
                                v-if="isShow(secondItem)"
                            >
                                <div class="centre-menu">
                                    <div @click="goToReport(index, indef)">
                                        <img src="@/assets/images/Fill 14.png" alt class="fill-left" />
                                        <div class="content">
                                            <span class="time">
                                                {{ getDealWith(secondItem.createTime, secondItem.utc)
                                                }}
                                            </span>
                                            <br />
                                            <span class="title">{{ showReportItem(secondItem) }}</span>
                                        </div>
                                    </div>
                                    <img
                                        v-if="!status"
                                        src="@/assets/images/sidebar/arrow-right.png"
                                        alt
                                        class="arrow-right"
                                    />
                                    <img
                                        v-else
                                        @click="deleteSubmit(secondItem.scanId)"
                                        src="@/assets/images/report/delete-bin-2-line@2x.png"
                                        alt
                                        class="arrow-right1"
                                    />
                                </div>
                                <!-- ai 入口 -->
                                <div
                                    class="centre-ai"
                                    v-if="(secondItem.abnormalConclusionInterpret !== null || secondItem.abnormalOutlineInterpret !== null)"
                                >
                                    <div
                                        class="centre-ai-item"
                                        v-if="secondItem.abnormalConclusionInterpret !== null"
                                        @click="goAi(secondItem)"
                                    >
                                        <img src="@/assets/images/report/ai1.png" alt />
                                        <span>{{ $t('ai.report') }}</span>
                                    </div>
                                    <div
                                        v-if="secondItem.abnormalOutlineInterpret !== null"
                                        @click="goAi(secondItem, 1)"
                                    >
                                        <img src="@/assets/images/report/ai2.png" alt />
                                        <span>{{ $t('ai.train') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-cell>
                </div>
            </van-list>
        </div>
        <div class="spring-frame" v-if="springStatus" style="background: #000000; opacity: 0.54"></div>
        <div class="spring-frame" v-if="springStatus">
            <div class="spring-frame-box">
                <h6>{{ $t('reportTips.title') }}</h6>
                <div class="btns">
                    <button class="dialog-delete" :disabled="deleting" @click="confirmDelete">
                        {{ deleting ? $t('model.btn.loading') : $t('reportTips.confirm') }}
                    </button>
                    <button class="dialog-cancel" :disabled="deleting" @click="cancelDelete">{{ $t('sidebar.btn.cancelBtn') }}</button>
                </div>
            </div>
        </div>
        <!-- <ai-loading v-if="aiLoading" :aiData="aiData" @goBack="aiLoading = false" @goAi="goAiUrl"></ai-loading> -->
    </div>
</template>
<script>
import { findUserMeasureHistory, deleteReport } from '@/assets/js/apolloGql.js'
import moment from 'moment'
import { _parseTimezoneToMinutes } from '@/assets/js/util.js'
// import AiLoading from '@/components/ai/aiLoading.vue'
export default {
    filters: {
        // getDealWith(value) {
        //     return moment(value * 1000).format("MM/DD HH:mm:ss");
        // }
    },
    // components: {
    //     AiLoading
    // },
    data() {
        return {
            dataArray: [],
            loading: false,
            finished: false,
            list: [],
            page: 1,
            status: false,
            springStatus: false,
            deleting: false,
            deletingScanId: null,
            loadTimer: null,
            isRead: false,
            sumLength: 0,
            deviceType: JSON.parse(window.localStorage.getItem('deviceType')),
            aiLoading: false,
            aiData: {},
        }
    },
    computed: {},
    created() {
        window.addEventListener('pageshow', function (event) {
            // 检测页面是否从缓存中加载
            if (event.persisted) {
                window.location.reload()
            }
        })
    },
    mounted() {
        this.findUserMeasureHistory().catch(() => this.$toast(this.$t('ai.loadingError1')))
    },
    beforeDestroy() {
        window.clearTimeout(this.loadTimer)
    },
    methods: {
        getDealWith(value, utc) {
            const formattedTimezone = _parseTimezoneToMinutes(utc.replace(/^(UTC|GMT)/, '').trim())
            // console.log('UTC 时间:',  moment(1735897574 * 1000).utcOffset(formattedTimezone).format("MM/DD HH:mm:ss"));
            // console.log('UTC 时间:888', formattedTimezone)
            if (this.$i18n.locale === 'ru-RU' || this.$i18n.locale === 'ar-AR') {
                return moment(value * 1000)
                    .utcOffset(formattedTimezone)
                    .format('DD/MM HH:mm')
            }
            return moment(value * 1000)
                .utcOffset(formattedTimezone)
                .format('MM/DD HH:mm:ss')
        },
        tipsSubmit(type) {
            if (type === 1) {
                this.status = true
            } else {
                this.status = false
            }
        },
        deleteSubmit(scanId) {
            if (this.deleting) return
            this.deletingScanId = scanId
            this.springStatus = true
        },
        cancelDelete() {
            if (this.deleting) return
            this.springStatus = false
            this.deletingScanId = null
        },
        async confirmDelete() {
            if (this.deleting || !this.deletingScanId) return
            this.deleting = true
            const scanId = this.deletingScanId
            try {
                const response = await this.$apollo.mutate({ mutation: deleteReport, variables: { scanId } })
                const result = response.data && response.data.deleteReport
                if (!result || (result.code !== 200 && result.code !== 202)) {
                    this.$toast(this.$t('reportTips.failed'))
                    return
                }
                this.springStatus = false
                this.deletingScanId = null
                // 刷新失败时也不能把已确认删除的报告留在当前列表。
                this.setHistory(this.dataArray.map(group => ({
                    ...group,
                    data: group.data.filter(report => report.scanId !== scanId),
                })).filter(group => group.data.length))
                this.$toast(this.$t(result.code === 202 ? 'reportTips.partial' : 'reportTips.success'))
                try {
                    await this.findUserMeasureHistory()
                } catch (error) {
                    // 已应用本地删除结果，保留上面的成功或同步失败提示。
                    console.warn('History refresh failed after deletion')
                }
            } catch (error) {
                this.$toast(this.$t('reportTips.failed'))
            } finally {
                this.deleting = false
            }
        },
        isShow(secondItem) {
            if (this.deviceType === 3) {
                return (
                    (secondItem.biaMeasure === 1 && secondItem.biaStatus === 1) ||
                    (secondItem.staticEval === 1 && (secondItem.bdaStatus === 1 || secondItem.evalStatus === 1)) ||
                    secondItem.bsShoulderStatus == 1 ||
                    secondItem.bsNeckStatus == 1 ||
                    (secondItem.girthMeasure == 1 && secondItem.bdaStatus == 1)
                )
            }
            return (
                (secondItem.biaMeasure === 1 && secondItem.biaStatus === 1) ||
                (secondItem.staticEval === 1 && (secondItem.bdaStatus === 1 || secondItem.evalStatus === 1)) ||
                secondItem.bsShoulderStatus == 1 ||
                secondItem.bsNeckStatus == 1 ||
                secondItem.balanceMeasure == 1
            )
        },
        setHistory(data) {
            window.clearTimeout(this.loadTimer)
            this.dataArray = data
            this.sumLength = data.reduce((total, group) => total + group.data.length, 0)
            this.page = 1
            this.renderHistoryPage()
        },
        renderHistoryPage() {
            let remaining = this.page * 10
            this.list = []
            for (const group of this.dataArray) {
                const reports = group.data.slice(0, remaining)
                if (reports.length) this.list.push({ year: group.year, data: reports })
                remaining -= reports.length
                if (remaining <= 0) break
            }
            this.isRead = true
            this.loading = false
            this.finished = this.page * 10 >= this.sumLength
        },
        onLoad() {
            window.clearTimeout(this.loadTimer)
            this.loadTimer = window.setTimeout(() => {
                this.page++
                this.renderHistoryPage()
            }, 0)
        },
        goToReport(index, indef) {
            let modelInfo = {
                bdaStatus: this.dataArray[index].data[indef].bdaStatus,
                biaMeasure: this.dataArray[index].data[indef].biaMeasure,
                biaStatus: this.dataArray[index].data[indef].biaStatus,
                bsShoulderScanResult: this.dataArray[index].data[indef].bsShoulderStatus,
                dynamicEval: this.dataArray[index].data[indef].dynamicEval,
                bsNeckScanResult: this.dataArray[index].data[indef].bsNeckStatus,
                createTime: this.dataArray[index].data[indef].createTime,
                evalStatus: this.dataArray[index].data[indef].evalStatus,
                girthMeasure: this.dataArray[index].data[indef].girthMeasure,
                memberId: JSON.parse(window.localStorage.getItem('modelInfo')).memberId,
                scanId: this.dataArray[index].data[indef].scanId,
                deviceId: this.dataArray[index].data[indef].deviceId,
                scanTime: this.dataArray[index].data[indef].scanTime,
                shoulderEval: this.dataArray[index].data[indef].shoulderJointEval,
                bsSpineStatus: this.dataArray[index].data[indef].bsSpineStatus,
                hipStatus: this.dataArray[index].data[indef].hipStatus,
                shoulder: this.dataArray[index].data[indef].shoulder,
                staticEval: this.dataArray[index].data[indef].staticEval,
                balanceMeasure: this.dataArray[index].data[indef].balanceMeasure,
                utc: this.dataArray[index].data[indef].utc,
            }
            this.$store.commit('setHistoryData', this.dataArray[index].data[indef])
            console.log(this.dataArray[index].data[indef], '>>>>>>>>>>>>>>>>>>>>>报告')
            window.localStorage.setItem('BmLastScanId', this.dataArray[index].data[indef].scanId)
            window.localStorage.setItem('modelInfo', JSON.stringify(modelInfo))
            setTimeout(() => {
                this.$router.push({
                    path: '/report',
                    query: { type: 1 },
                })
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        async findUserMeasureHistory() {
            const res = await this.$apollo.query({
                query: findUserMeasureHistory,
                fetchPolicy: 'network-only',
                variables: {
                    deviceType: JSON.parse(window.localStorage.getItem('deviceType')),
                    unit: window.localStorage.getItem('unit'),
                    lang: window.localStorage.getItem('lang'),
                },
            })
            const result = res.data && res.data.findUserMeasureHistory
            if (!result || result.code !== 200 || !Array.isArray(result.data)) {
                throw new Error('History request failed')
            }
            this.setHistory(result.data)
        },
        touchstart() {
            this.lastY = event.changedTouches[0].clientY // 点击屏幕时记录最后一次Y坐标
        },
        touchmove() {
            let y = event.changedTouches[0].clientY
            let st = this.$refs.sectionBox.scrollTop // 滚动条高度
            if (y >= this.lastY && st <= 0) {
                //若滚动到顶部且为下拉情况
                this.lastY = y
                event.preventDefault()
            }
            try {
                let clientHeight = document.querySelector('.section').clientHeight
                let scrollHeight = document.querySelector('.section').scrollHeight
                if (st + clientHeight === scrollHeight && y < this.lastY) {
                    // 若滚动到底部且为上拉情况
                    this.lastY = y
                    event.preventDefault()
                }
                this.lastY = y
            } catch (e) {
                console.log(e)
            }
        },
        showReportItem(secondItem) {
            const items = []
            if (secondItem.biaMeasure === 1 && secondItem.biaStatus === 1) {
                items.push(this.$t('report.tabPane.labelList[2]'))
            }
            if (secondItem.staticEval === 1 && (secondItem.bdaStatus === 1 || secondItem.evalStatus === 1)) {
                items.push(this.$t('report.tabPane.labelList[3]'))
            }

            if (
                secondItem.bdaStatus === 1 &&
                secondItem.girthMeasure == 1 &&
                (this.deviceType === 3 || this.deviceType === 4)
            ) {
                items.push(this.$t('girth.title'))
            }
            if (secondItem.shoulder === 1) {
                items.push(this.$t('report.tabPane.labelList[4]'))
            }
            if (secondItem.dynamicEval === 1) {
                items.push(this.$t('neckReport.title'))
            }
            console.log(secondItem, 'secondItem')
            if (secondItem.hipStatus === 1 && this.deviceType === 4) {
                items.push(this.$t('tun-xing-ping-gu'))
            }
            if (secondItem.bsSpineStatus === 1 && this.deviceType === 4) {
                items.push(this.$t('ji-zhu-ping-gu'))
            }
            if (secondItem.balanceMeasure === 1) {
                items.push(this.$t('balanceReport.balanceTittle'))
            }
            return items.join('、')
        },
        goAi(secondItem, statue) {
            let goUrl = secondItem.aiUrl
            if (statue) {
                goUrl = `${goUrl}&toPage=train#/pages/aiReport/train`
            }
            window.location.href = goUrl

            // this.aiData= {
            //     url: secondItem.aiUrl,
            //     abnormalConclusionInterpret: secondItem.abnormalConclusionInterpret,
            //     abnormalOutlineInterpret: secondItem.abnormalOutlineInterpret,
            //     scanId: secondItem.scanId,
            //     statue
            // }

            // this.aiLoading= true
        },
        // goAiUrl(url) {
        //     window.location.href = url
        // }
    },
}
</script>
<style lang="less" scoped>
.history-list {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: url(../../assets/images/report/history_bj.png);
    background-size: 100% 100%;
    position: relative;
    top: 0;

    /deep/.van-cell {
        padding: 0 !important;
        background: none;

        &:after {
            border-bottom: none;
        }
    }

    .van-cell__value {
        white-space: normal;
    }

    .header-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 15px;
        width: 100%;
        top: 0;
        z-index: 100;

        > span {
            img {
                display: block;
            }
        }

        .menu-info {
            width: 24px;
            height: 24px;
        }

        > div {
            img {
                position: relative;
                top: 2px;
                display: inline-block;
            }

            //     font-family: PingFangSC-Regular, PingFang SC;
            //     font-weight: 400;
            //     font-size: 25px;
            //     color: #222222;
            //     background: linear-gradient(90deg, #00E3C9 0%, #009FE8 100%);
            //     -webkit-background-clip: text;
            //     -webkit-text-fill-color: transparent;
            //     span{
            //         line-height: 25px;
            //         font-size: 15px;
            // }
        }
    }

    .scantime {
        font-size: 15px;
        color: #8aa3be;
        text-align: left;
        margin-left: 20px;
    }

    &.tr-TR,
    &.de-DE,
    &.fr-FR {
        .centre-menu {
            position: relative;
            margin: 10px 0;
            width: 355px;
            height: 82px;
            border-radius: 4px;
            background: #303c5c;

            .content {
                position: absolute;
                top: 16px;
                left: 64px;
                width: 250px;
                text-align: left;
                color: #8aa3be;
            }
        }
    }

    .centre-menu-item {
        border-radius: 4px;
        background: #303c5c;
        width: 355px;
        min-height: 76px;
        margin: 0 11px;
    }

    .centre-menu {
        position: relative;
        margin: 10px 0 0;
        min-height: 73px;

        .content {
            position: absolute;
            top: 16px;
            left: 64px;
            width: 250px;
            text-align: left;
            color: #8aa3be;

            .time {
                font-size: 14px;
            }

            .title {
                position: absolute;
                top: 22px;
                font-size: 12px;
                line-height: 14px;
            }
        }
    }

    .centre-ai {
        margin: 0;
        display: flex;
        padding: 0 17px 10px;

        div {
            padding: 0px 12px;
            display: flex;
            align-items: center;
            align-content: center;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            background: #2e4ea1;
            border-radius: 2px;

            img {
                margin-right: 6px;
                height: 15px;
            }

            span {
                margin-top: 5px;
            }
        }

        .centre-ai-item {
            margin-right: 16px;
        }
    }

    .fill-left {
        position: absolute;
        width: 32px;
        height: 32px;
        top: 22px;
        left: 18px;
    }

    .arrow-right {
        position: absolute;
        top: 31px;
        right: 10px;
        width: 8px;
        height: 14px;
    }

    .arrow-right1 {
        position: absolute;
        top: 20px;
        right: 12px;
        width: 24px;
        height: 24px;
    }

    .spring-frame {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        text-align: center;

        .spring-frame-box {
            width: 302px;
            // min-height: 160px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 6px;
            backdrop-filter: blur(10px);
            margin: 222px auto;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            h6 {
                width: 238px;
                margin: 32px;
                // height: 20px;
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 20px;
            }

            // 参考公共组件 van-dialog 按钮范式（productModel.vue）：左右排版，无背景按钮渐变描边，有背景按钮渐变填充。
            .btns {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 32px;

                button {
                    text-align: center;
                    width: 112px;
                    height: 34px;
                    border-radius: 5px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;

                    &:disabled {
                        opacity: 0.5;
                    }
                }

                // 删除：无背景色，渐变描边。
                .dialog-delete {
                    margin-right: 15px;
                    color: #222222;
                    border: 1px solid transparent;
                    background: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) padding-box,
                        linear-gradient(90deg, #00e3c9 0%, #009fe8 100%) border-box;
                }

                // 取消：渐变背景色。
                .dialog-cancel {
                    color: #222222;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                }
            }
        }
    }
}

.ar-AR {
    .header-menu {
        direction: rtl;

        .img {
            -webkit-transform: scaleX(1);
        }
    }

    .scantime {
        text-align: right;
        margin-right: 16px;
    }

    .arrow-right {
        left: 20px;
        -webkit-transform: scaleX(-1);
    }

    .fill-left {
        left: 0;
        margin-left: 300px;
    }

    .centre-menu {
        height: 90px;
        position: relative;

        .content {
            position: absolute;
            left: auto;
            right: 64px;
            margin-left: 97px;

            text-align: right;

            .title {
                right: 0;
                width: 200px;
                line-height: 16px;
            }
        }
    }

    .arrow-right1 {
        right: 320px;
        top: 26px;
    }

    .spring-frame .spring-frame-box .btns {
        direction: rtl;

        .dialog-delete {
            margin-right: 0;
            margin-left: 15px;
        }
    }

    ::v-deep .van-list {
        .van-list__loading .van-loading__text {
            direction: rtl;
        }
    }

    .centre-ai {
        direction: rtl;
        justify-content: flex-start;

        .centre-ai-item {
            margin-right: 0;
            margin-left: 16px;
        }
    }

    .centre-ai-item {
        margin-right: 0;
        margin-left: 16px;
    }
}

.sv-SE {
    .centre-menu {
        height: 90px;
    }
}

&.en-US,
&.pl-PL .m60History {
    min-height: 86px !important;

    .centre-menu {
        min-height: 90px;
    }
}

&.fi-FI .m60History {
    .centre-menu {
        min-height: 90px;
    }
}

&.el-GR .m60History {
    .centre-menu {
        min-height: 100px;
    }

    .centre-ai {
        div {
            padding: 0px 9px;
        }
    }
}
</style>
